/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-22T15:12:16.198
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentPlaceOrderRetreat,
	listRentPlaceOrderRetreatInit,
	listRentPlaceOrderRetreatByAuthorizations,
	deleteRentPlaceOrderRetreat
	
} from '@api/rentmanage/RentPlaceOrderRetreat';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentPlaceOrderRetreat({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPlaceOrderRetreat(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPlaceOrderRetreatByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPlaceOrderRetreatByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentPlaceOrderRetreatInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentPlaceOrderRetreatInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentPlaceOrderRetreat({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentPlaceOrderRetreat({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
